import WidgetNewUsers from './WidgetNewUsers';



export default WidgetNewUsers;
